module.exports = __webpack_public_path__ + "static/img/中工云课堂1.ccd0f1d2.png";